import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { HomeIcon, MessageCircleIcon, UsersIcon, CalendarIcon, FileTextIcon, Package } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

export function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { profile } = useAuth();

  const isActive = (path: string) => {
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  return <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-40">
      <div className="flex justify-around items-center h-16">
        <NavItem icon={HomeIcon} label="Home" active={isActive('/dashboard')} onClick={() => navigate('/dashboard')} />
        <NavItem icon={MessageCircleIcon} label="Chats" active={isActive('/chats')} onClick={() => navigate('/chats')} />
        <NavItem icon={UsersIcon} label="Clients" active={isActive('/clients')} onClick={() => navigate('/clients')} />
        <NavItem icon={Package} label="Inventory" active={isActive('/inventory')} onClick={() => navigate('/inventory')} />
        <NavItem icon={CalendarIcon} label="Schedule" active={isActive('/schedule')} onClick={() => navigate('/schedule')} />
        <NavItem icon={FileTextIcon} label="Templates" active={isActive('/templates')} onClick={() => navigate('/templates')} />
      </div>
    </nav>;
}
function NavItem({
  icon: Icon,
  label,
  active = false,
  onClick
}: {
  icon: any;
  label: string;
  active?: boolean;
  onClick?: () => void;
}) {
  return <button onClick={onClick} className="flex flex-col items-center justify-center gap-1 min-w-[60px] transition-transform active:scale-95">
      <Icon className={`w-6 h-6 transition-colors ${active ? 'text-[#5B8E87]' : 'text-gray-500'}`} />
      <span className={`text-xs transition-colors ${active ? 'text-[#5B8E87] font-semibold' : 'text-gray-500'}`}>
        {label}
      </span>
    </button>;
}
